const stage = window.location.origin.toString().includes('localhost:') ? 'dev' : 'prod';
//const stage = 'prod';
const API_BASE = (stage === 'prod') ? 'https://api.docpusher.com' : 'http://localhost:3000/dev';

// So we can use the VueToastr stuff
import {app} from '../main.js'; 

// Clear 
function clear_auth() {
  localStorage.clear();
}

function api_request(method, url, headers, body, authenticated) {
    return new Promise(function(resolve, reject) {
        var response_body = "";
        url = `${API_BASE}${url}`;
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
              try {
                response_body = JSON.parse(xhr.responseText);
              } catch(e) {
                resolve(xhr.responseText);
                return
              }
              if(response_body.success) {
                resolve(response_body.result);
              } else {
                if(response_body.statusCode === 401 && response_body.error === 'Unauthorized') {
                  clear_auth();
                  location.reload();
                  return
                }
                if(app) {
                  app.$toastr.e(
                    'An error occurred while performing your request.',
                    response_body.msg
                  );
                }
                reject(response_body);
              }
            }
        }
        xhr.onerror = function() {
            reject();
        }
        xhr.open(
            method,
            url,
            true
        );
        xhr.withCredentials = authenticated;

        const auth_token = localStorage.getItem('auth_token');
        if(authenticated && auth_token) {
          xhr.setRequestHeader('X-DocPusher-Token', auth_token);
        }

        xhr.setRequestHeader('X-CSRF-Header', 'True');
        
        if(!headers) {
          xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
          body = JSON.stringify(body);
        } else {
          headers.map(function( header_object ) {
            xhr.setRequestHeader(header_object.key, header_object.value);
          });
        }
        xhr.send(JSON.stringify(body));
    });
}

async function get_authentication_token(google_auth_token) {
  return api_request(
    'POST',
    '/authenticate',
    [],
    {
      'id_token': google_auth_token
    },
    true
  );
}

async function create_new_site(subdomain, theme) {
  return api_request(
    'POST',
    '/newsite',
    [],
    {
      'subdomain': subdomain,
      'theme': theme
    },
    true
  );
}

async function subdomain_exists(subdomain) {
  const result = await api_request(
    'POST',
    '/checksubdomain',
    [],
    {
      'subdomain': subdomain
    },
    true
  );

  return result.exists;
}

async function get_user_site_ids() {
  const result = await api_request(
    'GET',
    '/user/sites',
    [],
    {},
    true
  );

  return result.site_ids;
}

async function get_changed_docs_for_site(site_id) {
  return api_request(
    'GET',
    `/site/${site_id}/build/changedocs`,
    [],
    {},
    true
  );
}

async function start_site_build(site_id) {
  return api_request(
    'POST',
    `/site/${site_id}/build/startbuild`,
    [],
    {},
    true
  );
}

async function set_site_config(site_id, site_config_yaml) {
  return api_request(
    'POST',
    `/site/${site_id}/config`,
    [],
    {
      'site_id': site_id,
      'config_yaml': site_config_yaml
    },
    true
  );
}

async function get_site_builds(site_id) {
  return api_request(
    'GET',
    `/site/${site_id}/build/status`,
    [],
    {},
    true
  );
}

async function get_theme_default_config(theme) {
  return api_request(
    'GET',
    `/themes/${theme}`,
    [],
    {},
    true
  );
}

async function add_domain(domain) {
  return api_request(
    'POST',
    `/domains/add`,
    [],
    {
      'domain': domain
    },
    true
  );
}

async function get_domains() {
  return api_request(
    'GET',
    `/domains`,
    [],
    {},
    true
  );
}

async function delete_domain(domain_id) {
  return api_request(
    'DELETE',
    `/domains/${domain_id}`,
    [],
    {},
    true
  );
}

async function recheck_domain(domain_id) {
  return api_request(
    'POST',
    `/domains/${domain_id}/recheck`,
    [],
    {},
    true
  );
}

async function associate_domain_with_site(domain_id, site_id) {
  return api_request(
    'POST',
    `/domains/${domain_id}/associate/${site_id}`,
    [],
    {},
    true
  );
}

async function dissociate_domain(domain_id) {
  return api_request(
    'POST',
    `/domains/${domain_id}/dissociate`,
    [],
    {},
    true
  );
}

async function get_user_info() {
  return api_request(
    'GET',
    `/me`,
    [],
    {},
    true
  );
}

export default {
  api_request,
  get_authentication_token,
  create_new_site,
  subdomain_exists,
  get_user_site_ids,
  get_changed_docs_for_site,
  start_site_build,
  set_site_config,
  get_site_builds,
  get_theme_default_config,
  add_domain,
  get_domains,
  delete_domain,
  recheck_domain,
  associate_domain_with_site,
  dissociate_domain,
  get_user_info
}